import { useEffect, useRef } from 'react';
import { useLocation } from '@reach/router';

const VirtualPageviewTracker = () => {
  const location = useLocation();
  const previousPath = useRef(null);

  useEffect(() => {
    if (previousPath.current === location.pathname) return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'virtualPageview',
      page_location: window.location.href,
      page_title: document.title,
      page_referrer: previousPath.current
        ? window.location.origin + previousPath.current
        : document.referrer,
    });

    previousPath.current = location.pathname;
  }, [location.pathname]);

  return null;
};

export default VirtualPageviewTracker;

